export default "/dist/fonts/vendor/monaco-editor/esm/vs/base/browser/ui/codicons/codicon/codicon.ttf?f6283f7ccaed1249d9ebbcc5a55d5970";